var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-modal" },
    [
      _vm.modalVisible
        ? _c(
            "modal",
            { attrs: { "hide-footer": true }, on: { close: _vm.onClosed } },
            [
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("section", { staticClass: "checkout-modal-content" }, [
                  _vm.eventNotFound
                    ? _c(
                        "div",
                        {
                          staticClass: "checkout-modal-section event-not-found",
                        },
                        [
                          _c("h3", { staticClass: "center" }, [
                            _vm._v("Sorry, we could not find that event."),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showEventDetail
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "checkout-modal-section checkout-section-events clearfix animated fadeInUp",
                        },
                        [
                          _c("event-detail", {
                            attrs: {
                              theme: "theme-light",
                              "event-id": _vm.event.id,
                              "hide-branding": true,
                              "hide-upcoming-events": true,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showCheckout
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "checkout-modal-section checkout-section-checkout clearfix",
                        },
                        [
                          _c("checkout", {
                            attrs: { "enable-guest-checkout": "true" },
                            on: {
                              bookingCompleted: _vm.onBookingCompleted,
                              checkoutSessionCreated:
                                _vm.onCheckoutSessionCreated,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/CheckoutModal/template.html?vue&type=template&id=971b726c&
// module id = 1038
// module chunks = 0